<template>
  <section class="section pt-0">
    <div class="container">
      <!-- Bienvenida -->
      <div class="">
        <div class="title is-3">
          ¡{{ $t("welcome") }}, {{ student.first_name }}!
        </div>
        <p class="subtitle is-5">Este es tu resumen académico.</p>
      </div>

      <!-- Resumen rápido -->
      <div class="columns is-multiline mt-5">
        <!-- Progreso Académico -->
        <div class="column is-4">
          <div class="has-text-centered">
            <p class="title is-5">Progreso</p>
            <div class="circular-progress">
              <svg viewBox="0 0 36 36">
                <path
                  class="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  class="circle"
                  :stroke-dasharray="`${progress}, 100`"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <text x="18" y="20.35" class="percentage">{{ progress }}%</text>
              </svg>
            </div>
          </div>
        </div>

        <!-- Nota Promedio -->
        <div class="column is-4">
          <div class="has-text-centered">
            <span class="icon is-large">
              <i class="fa fa-graduation-cap fa-2x"></i>
            </span>
            <p class="title is-5 mt-2">Nota Promedio</p>
            <p class="subtitle is-3 has-text-primary">{{ averageGrade }}</p>
          </div>
        </div>

        <!-- Pagos Pendientes -->
        <div class="column is-4">
          <div class="has-text-centered">
            <span class="icon is-large">
              <i class="fa fa-wallet fa-2x"></i>
            </span>
            <p class="title is-5 mt-2">Pagos Pendientes</p>
            <p class="subtitle is-3 has-text-danger">{{ pendingPayments }}</p>
          </div>
        </div>
      </div>

      <!-- Accesos Rápidos -->
      <h2 class="title is-4 mt-6">Accesos Rápidos</h2>
      <div class="columns is-multiline">
        <div class="column is-3" v-for="card in cards" :key="card.title">
          <div class="card hover-card" @click="navigate(card.route)">
            <div class="card-content has-text-centered">
              <span class="icon is-large">
                <i :class="card.icon"></i>
              </span>
              <p class="title is-6 mt-2">{{ card.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import { ref } from "vue";
// import { useRouter } from "vue-router";

// const router = useRouter();

// const studentName = ref("Juan Pérez");
// const progress = ref(95); // porcentaje de progreso académico
// const averageGrade = ref(87); // nota promedio
// const pendingPayments = ref("Q500"); // cantidad pendiente de pagos

// const cards = ref([
//   { title: "Mis Cursos", icon: "fa fa-book fa-2x", route: "/cursos" },
//   { title: "Notas", icon: "fa fa-graduation-cap fa-2x", route: "/notas" },
//   { title: "Pagos", icon: "fa fa-credit-card fa-2x", route: "/pagos" },
//   { title: "Mensajes", icon: "fa fa-envelope fa-2x", route: "/mensajes" },
//   { title: "Perfil", icon: "fa fa-user fa-2x", route: "/perfil" },
// ]);

// const navigate = (route) => {
//   router.push(route);
// };

export default {
  name: "StudentPortal",
  components: {},
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      studentName: "Juan Pérez",
      progress: 67, // porcentaje de progreso académico
      averageGrade: 82, // nota promedio
      pendingPayments: "Q500", // cantidad pendiente de pagos
      cards: [
        {
          title: v.$t("my courses"),
          icon: "fa fa-book fa-2x",
          route: "/student-portal/courses",
        },
        {
          title: v.$t("payments"),
          icon: "fa fa-credit-card fa-2x",
          route: "/student-portal/payments",
        },
        {
          title: v.$t("messages"),
          icon: "fa fa-envelope fa-2x",
          route: "/student-portal/messages",
        },
        {
          title: v.$t("profile"),
          icon: "fa fa-user fa-2x",
          route: "/student-portal/profile",
        },
        {
          title: v.$t("events"),
          icon: "fa fa-calendar fa-2x",
          route: "/student-portal/events",
        },
      ],
    };
  },
  computed: {},
  methods: {
    navigate(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.circular-progress {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  transform: rotate(0.25turn);
}
svg {
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
}
.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}
.circle {
  fill: none;
  stroke: #00d1b2;
  stroke-width: 2.8;
  stroke-linecap: round;
}
.percentage {
  fill: #00d1b2;
  font-size: 0.5em;
  text-anchor: middle;
}
.hover-card {
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}
.hover-card:hover {
  /* transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); */
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.hover-card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}
</style>
